import { useEffect, useRef, useState } from "react";
import { BarChart3, Camera, Image, Palette, Ruler, Shapes, Shield, UserRound } from "lucide-react";

export const MOBILE_TABS = [
  ["style", "Style", Shapes], ["background", "Background", Image], ["colours", "Colours", Palette], ["photo", "Photo", Camera],
  ["details", "Name", UserRound], ["crest", "Badge", Shield], ["stats", "Stats", BarChart3], ["size", "Size", Ruler],
];

export const useIsMobile = () => {
  const q = "(max-width: 1023px)";
  const [m, setM] = useState(() => window.matchMedia(q).matches);
  useEffect(() => {
    const mq = window.matchMedia(q);
    const on = () => setM(mq.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return m;
};

// One-tap section switcher shown under the sticky mobile preview.
export const MobileTabs = ({ tab, onTab }) => {
  const bar = useRef(null);
  useEffect(() => { bar.current?.querySelector('[aria-selected="true"]')?.scrollIntoView({ inline: "center", block: "nearest", behavior: "smooth" }); }, [tab]);
  return (
    <nav ref={bar} role="tablist" aria-label="Designer sections" className="-mx-4 mt-2 flex w-0 min-w-[calc(100%+2rem)] gap-1 overflow-x-auto px-3 pb-0.5" data-testid="mobile-section-tabs">
      {MOBILE_TABS.map(([id, label, Icon], i) => (
        <button key={id} type="button" role="tab" aria-selected={tab === id} onClick={() => onTab(id)} data-testid={`mobile-tab-${id}`}
          className={`flex min-w-[64px] shrink-0 flex-col items-center gap-0.5 border-2 px-2 py-1.5 text-[11px] font-bold uppercase leading-none transition-colors ${tab === id ? "border-slate-900 bg-slate-900 text-lime-300" : "border-slate-300 bg-white text-slate-700"}`}>
          <Icon className="h-4 w-4" /><span>{i + 1}. {label}</span>
        </button>
      ))}
    </nav>
  );
};
